<template>
    <NotificationList class="p-2 b-a-2 bg-white" :notices="user.attributes || []" :user="user" @change="changeNotice" />
</template>

<script>
import { mapActions } from 'vuex'
import NotificationList from './../components/NotificationList'

export default {
    name: 'Notification',

    components: {
        NotificationList,
    },

    props: {
        user: {
            default() {
            }
        }
    },

    methods: {
        ...mapActions({
            edit: 'notification/edit'
        }),
        changeNotice(key, value) {
            this.edit({ key: key, value: value, user_id: this.user.id })
        }
    }
}
</script>